import { useState } from 'react';
import { tableColumnConfigs } from './TableHeader.consts';
import { TableHeaderProps } from './TableHeader.types';
import {
  CheckIcon,
  MinusIcon,
  SortAscIcon,
  SortDescIcon
} from '../../../../../icons/SvgIcons';
import CheckboxItem from '../../../../ui/Checkbox/Checkbox';
import { MAX_BULK_DELETE_AI_SYSTEMS } from '../../../../../constants/AISystems.constants';

export function TableHeader({
  className = '',
  type,
  sortBy,
  sortOrder,
  onSort,
  hiddenColumnKeys = [],
  selectionChecked = false,
  onHeaderSelection,
  selectionDisabled = false,
  allSystemSelected
}: TableHeaderProps) {
  const columns = tableColumnConfigs[type].filter(
    (column) => !column.sortKey || !hiddenColumnKeys.includes(column.sortKey)
  );
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);

  const handleSort = (sortKey: string) => {
    if (onSort) {
      onSort(sortKey);
    }
  };

  return (
    <thead className={`w-full ${className}`}>
      <tr className="w-full flex flex-row">
        {onHeaderSelection && (
          <th className="min-w-10 flex items-center justify-center bg-gray-40">
            <CheckboxItem
              value="all-ai-systems"
              label={
                selectionChecked
                  ? 'Clear selection'
                  : `Select up to ${MAX_BULK_DELETE_AI_SYSTEMS} loaded AI systems`
              }
              textClasses="sr-only"
              checked={selectionChecked}
              onChange={onHeaderSelection}
              disabled={selectionDisabled}
              icon={allSystemSelected ? CheckIcon() : MinusIcon()}
            />
          </th>
        )}
        {columns.map((column, index) => {
          const isActive = sortBy === column.sortKey && sortOrder;
          const isHovered = hoveredColumn === column.sortKey;
          const showIcon = column.sortable && (isActive || isHovered);

          return (
            <th
              key={index}
              className={`${
                column.width
              } flex items-center py-3 px-6 gap-1 bg-gray-40 text-xs font-medium tracking-wider text-gray-550 hover:text-gray-850 uppercase ${
                column.className || ''
              } ${
                column.sortable
                  ? 'cursor-pointer transition-colors hover:bg-gray-100'
                  : ''
              }`}
              onMouseEnter={() =>
                column.sortable && setHoveredColumn(column.sortKey || null)
              }
              onMouseLeave={() => setHoveredColumn(null)}
              onClick={() =>
                column.sortable && column.sortKey && handleSort(column.sortKey)
              }
            >
              {column.label}
              <span>
                {showIcon &&
                  (sortOrder === 'desc' ? SortDescIcon() : SortAscIcon())}
              </span>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
